export enum UploadStatus {
  Pending = "pending",
  Done = "done",
  Error = "error",
}
